<template>
  <div class="sports-header">
    <div
      class="sport-item"
      :class="{ active: selectedSport && sport.id == selectedSport.id, disabled: !sport.active }"
      v-for="sport in convertedSports"
      @click="selectSport(sport)"
      :key="sport.id">
      <i
        class="icon"
        :class="[ 'n-i-live-' + sport.providerId]"
      />
      <div class="sport-name">
        {{ sport.name }}
        <span>({{ sport.numberOfMatches }})</span>
      </div>
    </div>
    <div
      @click="showSportsModal = true"
      class="sport-item alt"
      v-if="displayMoreSports">
      <i class="icon n-i n-i-arrow-down-a"/>
      <div class="sport-name">{{ getTranslation('main.show_all') }}</div>
    </div>
    <modal
      @modalclosed="showSportsModal = false"
      :show="showSportsModal">
      <div slot="header">{{ getTranslation('sport.all_sports') }}</div>
      <div slot="body">
        <div class="sports-modal">
          <div
            class="sport-item"
            :class="{
              active: selectedSport && sport.id == selectedSport.id,
              disabled: !sport.active,
            }"
            v-for="sport in sports"
            @click="selectSport(sport)"
            :key="sport.id">
            <i
              class="icon"
              :class="[ 'n-i-live-' + sport.providerId]"
            />
            <div class="sport-name">
              {{ sport.name }}
              <span>({{ sport.numberOfMatches }})</span>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../modal/Modal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      showSportsModal: false,
      offerRoutes: ['TopOffer', 'Offer'],
      displayMoreSports: false,
      limit: 0,
    };
  },
  computed: {
    selectedSport() {
      return this.$store.getters.getActiveSportByRoute(this.$route.name);
    },
    sports() {
      return this.$store.getters.getSportsByRoute(this.$route.name);
    },
    convertedSports() {
      return _.take(_.sortBy(this.sports, ['position']), this.limit);
    },
  },
  props: {
    selectedProviderId: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  mounted() {
    this.calculateSportsFitNumber();
    if (this.$route.name === 'OutrightsTournament') return;

    if (!this.selectedProviderId) {
      const foundSport = _.find(
        this.sports,
        item => !_.isEmpty(this.selectedSport) && this.selectedSport.id === item.id,
      );

      if (!foundSport) {
        this.selectSport(this.convertedSports[0]);
      }
    } else {
      const foundSport = _.find(this.sports, { providerId: this.selectedProviderId });

      if (!foundSport) {
        this.selectSport(this.convertedSports[0]);
      } else {
        this.selectSport(foundSport);
      }
    }
  },
  methods: {
    selectSport(sport) {
      const index = _.indexOf(this.offerRoutes, this.$route.name);
      const actionName = index !== -1 ? 'setActiveSport' : 'setActiveOutrightsSport';

      this.$store.dispatch(actionName, sport);
      this.$store.dispatch('setActiveCategory', null);
      this.$store.dispatch('setActiveTournament', null);

      if (this.$route.name === 'OutrightsTournament') {
        this.$router.push({
          name: 'Outrights',
          params: {
            sportId: sport.providerId,
          },
        });
      }
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    calculateSportsFitNumber() {
      const sportItemWidth = 75;
      const windowWidth = window.innerWidth;
      // calculate betslip width
      const viewWidth = windowWidth > 1200 ? windowWidth - ((25 / 100) * windowWidth) : windowWidth;
      const sportsWidth = this.sports.length * sportItemWidth;
      const widthDiff = sportsWidth - viewWidth;
      const numberOfHiddenMatches = Math.ceil(widthDiff / sportItemWidth) + 1;

      this.limit = this.sports.length - numberOfHiddenMatches;
      this.displayMoreSports = viewWidth < sportsWidth;
    },
  },
};
</script>

<style lang="scss">
@import '../../../scss/default/components/sports-header';
</style>
